import { Component, OnInit } from '@angular/core';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-admin-dealer-report-search',
  templateUrl: './admin-dealer-report-search.component.html',
  styleUrls: ['./admin-dealer-report-search.component.scss']
})
export class AdminDealerReportSearchComponent implements OnInit {

  profile: DealerProfile;

  constructor(private route: ActivatedRoute, private readonly router: Router) {
  }

  ngOnInit() {
    this.route.parent.data.subscribe((data) => {
      this.profile = data.profile;
      if(!this.profile.bulkDataReport) {
        this.router.navigate([`/admin/dealer/${this.profile.id}/report-log`]);
      }
    });
  }

}
